export default {
  unknown: 'Whoops.. An error occurred',
  message: {
    addMessage: 'The message added!',
    editMessage: 'The message updated!'
  },
  advice: {
    deleted: 'Advice deleted!',
    kpiAdded: 'KPI added!',
    kpiEdited: 'Message updated!',
    kpiDeleted: 'Message deleted!'
  },
  user: {
    passwordEdited: 'Password updated!',
    passwordSent: 'An email has been sent to reset your password.',
    profileEdited: 'Information updated!'
  },
  error: {
    fillForm: 'You need to fill in the form.',
    smallPassword: 'Password should be minimum 8 characters.',
    passwordDifferent: 'The passwords don\'t seem to match',
    session: 'Your session has expired, please try logging in again.'
  },
  customer: {
    created: 'Customer added!',
    edited: 'Customer updated!',
    deleted: 'Customer successfully deleted!'
  },
  badge: {
    edited: 'Badge updated!',
    deleted: 'Badge Deleted!',
    removedEvent: 'Event unlinked.',
    pasted: 'Badge pasted!'
  },
  campaign: {
    edited: 'Campaign updated!',
    added: 'Campaign added!',
    deleted: 'Campaign deleted!',
    defineName: 'Give the campaign a name!',
    startDate: 'Select a start date or remove the time limitation.',
    endDate: 'Select an end date or remove the time limitation.'
  },
  bubble: {
    added: 'Bubble added!',
    edited: 'Bubble updated!',
    refreshed: 'Bubble refreshed!',
    deleted: 'Bubble deleted!',
    eventRemoved: 'Event removed for this bubble.'
  },
  challenge: {
    updated: 'Challenge updated!',
    published: 'Challenge published!',
    deleted: 'Challenge deleted!'
  },
  contest: {
    deleted: 'Contest deleted!',
    added: 'Contest added!',
    edited: 'Contest edited!.'
  },
  event: {
    edited: 'Event updated!',
    added: 'Event added!',
    deleted: 'Event deleted!'
  },
  library: {
    added: 'Library created!',
    deleted: 'Library deleted!',
    mediaAdded: 'Media added!'
  },
  round: {
    deleted: 'Round deleted!',
    responsesSaved: 'Responses saved!',
    mancheEdited: 'Updated!',
    mancheAdded: 'Added!'
  },
  settings: {
    edited: 'Settings updated!',
    invalidIp: 'Invalid IP address!'
  },
  manager: {
    added: 'Manager added!',
    deleted: 'Manager deleted!'
  },
  translations: {
    edited: 'Translations updated!'
  },
  site: {
    added: 'Site added!'
  },
  wave: {
    added: 'Wave added!',
    duplicated: 'Wave duplicated!',
    edited: 'Wave updated!',
    deleted: 'Wave deleted!'
  },
  banner: {
    added: 'Banner added!',
    duplicated: 'Banner duplicated!',
    edited: 'Banner updated!',
    deleted: 'Banner deleted!',
    cloned: 'Banner cloned!',
    parameters: {
      url: 'URL parameter is required!'
    }
  },
  survey: {
    added: 'Survey NPS added!',
    edited: 'Survey NPS updated!',
    deleted: 'Survey NPS deleted!'
  },
  wheel: {
    added: 'Wheel added!',
    edited: 'Wheel updated!',
    deleted: 'Wheel deleted!'
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/notifications.js